import {LobbyWrapperDefaultBox} from "./lobby-wrapper.default.box";
import {styledByTheme} from "../../themes/architecture/styled-by-theme";
import {LobbyWrapperCasino777Box} from "./lobby-wrapper.casino777.box";

export const LobbyWrapperBox = styledByTheme(LobbyWrapperDefaultBox).forCasino777(LobbyWrapperCasino777Box).apply();